import { useTranslation } from "react-i18next";
import styles from "./Footer.module.css";
import { Mail } from "lucide-react";
import "./../../../assets/fontawesome/css/brands.css";
import "./../../../assets/fontawesome/css/solid.css";
import "./../../../assets/fontawesome/css/fontawesome.css";

const formatter = new Intl.NumberFormat("fa-IR");
const footerDictionary = {
  en: {
    inviteText: "HAVE SOMETHING IN MIND?",
    inviteTextSpan: "LET'S TALK.",
    email: "Email",
    linkedIn: "LinkedIn",
    github: "Github",
    name: "FARZAD YOUSEFI",
    slogan: "Made with curiosity.",
    telegram: "Telegram",
    phone: "Phone",
  },
  fa: {
    inviteText: "ایده‌ای برای همکاری داری؟",
    inviteTextSpan: "بیا صحبت کنیم.",
    email: "ایمیل",
    linkedIn: "لینکدین",
    github: "گیت‌هاب",
    name: "فرزاد یوسفی",
    slogan: "محصول خلاقیت.",
    telegram: "تلگرام",
    phone: "تلفن",
  },
};

export function Footer() {
  const { i18n } = useTranslation();
  const lang = i18n.language;
  return (
    <>
      <footer className={styles.footerContainer}>
        <div className={styles.inviteContainer}>
          <h2>{footerDictionary[lang].inviteText}</h2>
          <br />
          <h2>
            <span>{footerDictionary[lang].inviteTextSpan}</span>
          </h2>
        </div>
        <div className={styles.contactContainer}>
          <div className={styles.columns}>
            <a href="mailto:Farzad.yousefi76@gmail.com" target="_blank">
              <i
                className="fa-solid fa-envelope"
                title={footerDictionary[lang].email}
              ></i>
            </a>
          </div>
          <div className={styles.columns}>
            <a href="tel:+989117811131" target="_blank">
              <i
                className="fa-solid fa-phone"
                title={footerDictionary[lang].phone}
              ></i>
            </a>
          </div>

          <div className={styles.columns}>
            <a href="https://github.com/F-Yousefi" target="_blank">
              <i
                className="fa-brands fa-github"
                title={footerDictionary[lang].github}
              ></i>
            </a>
          </div>
          <div className={styles.columns}>
            <a href="https://t.me/farzad_yousefi76" target="_blank">
              <i
                className="fa-brands fa-telegram"
                title={footerDictionary[lang].telegram}
              ></i>
            </a>
          </div>
          <div className={styles.columns}>
            <a
              href="https://www.linkedin.com/in/farzad-yousefi-ai"
              target="_blank"
            >
              <i
                className="fa-brands fa-linkedin"
                title={footerDictionary[lang].linkedIn}
              ></i>
            </a>
          </div>
        </div>
      </footer>
      <footer className={styles.copyRight}>
        <label style={{ insetInlineStart: "3em" }}>
          &copy; {footerDictionary[lang].name}
        </label>
        <label style={{ insetInlineEnd: "3em" }}>
          {footerDictionary[lang].slogan}
        </label>
      </footer>
    </>
  );
}
